export default "__VITE_ASSET__CLNAqLRo__"